import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../../../../Redux/slice/features/paginationSilce";
import { onlineHBookingColumns } from "./OnlineHBookingData";
import DataTable from "../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";
import { REACT_APP_API_URL } from "../../../../../env";
import { fetchUserDetails, rehydrateAuthState } from "../../../../../Redux/slice/features/authSlice";

const OnlineHBookingTable = () => {
  const today = new Date().toISOString().split("T")[0];
  const { user } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const { currentPage, itemsPerPage } = useSelector(
    (state) => state.pagination
  );
  useEffect(() => {
      dispatch(rehydrateAuthState());
      dispatch(fetchUserDetails());
    }, [dispatch]);
  const [data, setData] = useState([]);
  const [hotelOptions, setHotelOptions] = useState([]);
  const [filters, setFilters] = useState({
    fromDate: today,
    toDate: today,
    hotelId: 0,
  });

  useEffect(() => {
    dispatch(setCurrentPage(1));
    fetchHotels();
  }, [dispatch]);

  const fetchHotels = useCallback(async () => {
    const HotelID = user?.user?.PropertyID;

    try {
      if (HotelID !== null && HotelID !== undefined) {
        const res = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/hotel/${HotelID}`
        );
        const hotel = res.data.data?.[0];

        if (hotel) {
          setHotelOptions([
            {
              value: hotel.PropertyID,
              label:
                hotel.UnitName ||
                hotel.PropertyName ||
                `Hotel ${hotel.PropertyID}`,
            },
          ]);
        } else {
          setHotelOptions([]);
        }
      } else {
        const res = await axios.get(
          `${REACT_APP_API_URL}api/room-tariff/get-hotels`
        );
        const formatted = (res.data.data || []).map((h) => ({
          value: h.PropertyID,
          label: h.UnitName,
        }));
        setHotelOptions(formatted);
      }
    } catch (err) {
      console.error("Error fetching hotel list:", err);
      setHotelOptions([]);
    }
  }, [user]);

  const fetchOnlineBookings = useCallback(async () => {
    try {
      const res = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/online-booking`,
        {
          ...filters,
          dtInterval: 0,
          pageNo: 0,
          pageSize: 0,
        }
      );

      const formatted = (res.data.data || []).map((item, index) => ({
        Sl: index + 1,
        ...item,
        TotalAmount: `₹ ${item.TotalAmount?.toFixed(2)}`,
      }));

      setData(formatted);
    } catch (err) {
      console.error("Error fetching online bookings:", err);
      setData([]);
    }
  }, [filters]);

  const handleShowClick = useCallback(() => {
    if (filters.fromDate && filters.toDate) {
      fetchOnlineBookings();
    } else {
      alert("Please select From Date and To Date");
    }
  }, [fetchOnlineBookings, filters]);

  const currentItems = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return data.slice(start, start + itemsPerPage);
  }, [data, currentPage, itemsPerPage]);

  const handleNextPage = useCallback(() => {
    dispatch(setCurrentPage(currentPage + 1));
  }, [dispatch, currentPage]);

  const handlePreviousPage = useCallback(() => {
    dispatch(setCurrentPage(currentPage - 1));
  }, [dispatch, currentPage]);

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        <input
          type="date"
          value={filters.fromDate}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, fromDate: e.target.value }))
          }
          className="border p-2 rounded"
        />
        <input
          type="date"
          value={filters.toDate}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, toDate: e.target.value }))
          }
          className="border p-2 rounded"
          style={{ marginLeft: "10px" }}
        />
        <select
          value={filters.hotelId}
          style={{ marginLeft: "10px" }}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, hotelId: Number(e.target.value) }))
          }
          className="border p-2 rounded"
        >
          <option value="0">-- Select Hotel --</option>
          {hotelOptions.map((hotel) => (
            <option key={hotel.value} value={hotel.value}>
              {hotel.label}
            </option>
          ))}
        </select>
        <button
          onClick={handleShowClick}
          style={{ marginLeft: "10px" }}
          className="btn btn-primary text-white rounded px-4 py-2 "
        >
          Show
        </button>
      </div>

      <DataTableHeader columns={onlineHBookingColumns} data={data} />
      <DataTable columns={onlineHBookingColumns} data={currentItems} enablePagination={false} />
      <DataTableFooter
        dataT={data}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        handleNextPage={handleNextPage}
        handlePreviousPage={handlePreviousPage}
      />
    </div>
  );
};

export default React.memo(OnlineHBookingTable);